export default "__VITE_PUBLIC_ASSET__25fc64e4__"